import * as yup from 'yup'

export const createAcessoUsuariosFormValues = {
    idGrupoAcesso: null,
    nome: '',
    login: '',
    senha: '',
    email: '',
    nroDocumento: '',
    dtNascimento: '',
}

export const createAcessoUsuariosFormSchema = yup.object().shape({
    idGrupoAcesso: yup.number().typeError('Campo obrigatório'),
    nome: yup.string().required('Campo obrigatório'),
    email: yup.string().email('E-mail inválido'),
    login: yup.string().required('Campo obrigatório'),
    senha: yup.string().required('Campo obrigatório'),
    nroDocumento: yup.string().required('Campo obrigatório'),
    dtNascimento: yup.string().required('Campo obrigatório'),
})